import { ReactNode } from 'react';

import { PublicClient } from 'viem';

import { QuestAccent } from './daily-quests-page.constants';

export type QuestId = string;

export enum QuestPeriod {
  Daily = 'daily',
  Weekly = 'weekly',
}

export enum NextTimeStatus {
  Ready = 'ready',
  Cooldown = 'cooldown',
  InProgress = 'in_progress',
  Claimed = 'claimed',
}

export enum QuestTypes {
  Daily = 'daily-login',
  DailyPlay = 'daily-play',
  DailyWin = 'daily-win',
  DailyPrizeCrate = 'daily-prize-crate',
  WeeklyStreak = 'weekly-streak',
}

export enum OverlayMode {
  None = 'none',
  Congrats = 'congrats',
}

export type OverlayState = OverlayMode;

export type QuestFrequency = QuestPeriod;

export type QuestStatus =
  | NextTimeStatus.Ready // claimable now
  | NextTimeStatus.Cooldown // locked until nextAvailableAt
  | NextTimeStatus.Claimed // already claimed for this period
  | NextTimeStatus.InProgress; // e.g., weekly streak mid-progress

export interface IQuestProgress {
  current: number;
  target: number;
}

export interface IQuest {
  id: QuestId;
  title: string;
  subtitle?: ReactNode;
  description: string;
  frequency: QuestFrequency;
  points: number;
  status: QuestStatus;
  progress?: IQuestProgress;
  nextAvailableAt?: number;
  accent: QuestAccent;
  isPrizeCrate?: boolean;
  href?: string;
}

export type UserQuestStruct = {
  nextDailyQuestTime: bigint; // seconds
  nextDailyGameTime: bigint; // seconds
  nextDailyWinTime: bigint; // seconds
  weekStreak: bigint; // 0..7
};

export interface IDailyQuestsViewProps {
  address: `0x${string}` | null | undefined;
  publicClient: PublicClient | null | undefined;
}
